import React from 'react';

type SnackbarContextProps = {
	setOpen: (value: boolean) => void;
};

export const SnackbarContext = React.createContext<SnackbarContextProps>({
	setOpen: (value: boolean) => {
		return;
	},
});
